import { DataGrid } from "@mui/x-data-grid";
import { autoSizeOptionsForDataGrid } from "constants/componentsConstants";
import { dataGridStateForDashboard } from "constants/dataGridConstants";

export const DataGridDashboardWrapper = ({ ...props }) => {
  return (
    <DataGrid
      {...props}
      disableRowSelectionOnClick
      initialState={dataGridStateForDashboard.initialState}
      pageSizeOptions={dataGridStateForDashboard.pageSizeOptions}
      autosizeOnMount
      autosizeOptions={autoSizeOptionsForDataGrid}
    />
  );
};
